import { getUrl } from 'helpers';

export default function Image({ alt, 'aria-hidden': ariaHidden, src, style }: ImageProps) {
    return (
        <picture>
            <img alt={alt} aria-hidden={ariaHidden} src={getUrl(src)} style={style} />
        </picture>
    );
}